import { h, Component } from 'preact'
import { addToCompare, removeFromCompare } from '../helpers/compare'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class AddToWishListButton extends Component {
  state = {
    isCurrentProductAdded: null
  }
  componentDidMount() {
    const compare = window.localStorage.getItem('compare')
    if (compare) {
      const array = JSON.parse(compare)
      let included = array.indexOf(parseInt(this.props.id, 10)) >= 0
      this.setState({
        isCurrentProductAdded: included
      })
    }
  }
  addProduct(productId) {
    this.setState(prevState => ({
      isCurrentProductAdded: !prevState.isCurrentProductAdded
    }))
    addToCompare(productId)
  }

  removeProduct(productId) {
    this.setState(prevState => ({
      isCurrentProductAdded: !prevState.isCurrentProductAdded
    }))
    removeFromCompare(productId)
  }

  render() {
    if (!this.state.isCurrentProductAdded) {
      return (
        <a
          className="c-product-intro-content__compare-link"
          onClick={() => {
            this.addProduct(this.props.id)
          }}
        >
          <svg
            className="c-icon c-icon--medium"
            dangerouslySetInnerHTML={{
              __html: '<use xlink:href="#compare"></use>'
            }}
          />
          vergelijk
        </a>
      )
    } else {
      return (
        <div>
          <a
            className="c-product-intro-content__compare-link c-product-intro-content__compare-link--cross"
            onClick={() => {
              this.removeProduct(this.props.id)
            }}
          >
            <svg
              className="c-icon c-icon--xsmall"
              dangerouslySetInnerHTML={{
                __html: '<use xlink:href="#compare"></use>'
              }}
            />
            verwijder uit vergelijking
          </a>
        </div>
      )
    }
  }
}

export default AddToWishListButton



// WEBPACK FOOTER //
// ./src/js/compare/components/AddToCompareButton.js